import React from "react";

export function DecoratedSeparator({
  backgroundClassName,
}: {
  backgroundClassName?: string;
}) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 2000 185"
      enableBackground="new 0 0 2000 185"
      xmlSpace="preserve"
      className={"w-full"}
    >
      <path
        fill="#74b731"
        d="M1999.5,0v15.59c-575.43,210.59-1406.39,216.59-1998,1.5V0C593.11,215.08,1424.07,210.58,1999.5,0z"
      ></path>
      <path
        className={backgroundClassName}
        d="M1999,185H0V13.1c591.61,215.09,1422.57,209.09,1998-1.5L1999,185z"
      ></path>
    </svg>
  );
}
